import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material"
import styleCss from "../Style/style"
import { Link, useNavigate } from "react-router-dom"
import React from "react";

const Help = () => {
    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const navigate = useNavigate();

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ md: 4, xs: 12 }}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            overflow: 'hidden',
                            marginBottom: '20px',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                        }}>
                            Quick Actions
                        </Typography>
                        <Typography sx={styleCss.CallTextStyle}>
                            <Link href="tel:1800XXXXXXX" style={{ textDecoration: 'unset', color: '#000', }}>Call Support: 1800-XXX-XXXX</Link>
                        </Typography>
                        <Typography sx={styleCss.CallTextStyle}>
                            <Link href="mailto:support@redbus.com" style={{ textDecoration: 'unset', color: '#000', }}> Email: support@redbus.com</Link>
                        </Typography>
                        <Typography sx={styleCss.CallTextStyle}>
                            <Link to={'/'} style={{ textDecoration: 'unset', color: '#000', }}>Start Live Chat</Link>
                        </Typography>
                        <Typography sx={styleCss.CallTextStyle}>
                            <Link to={'/'} style={{ textDecoration: 'unset', color: '#000', }}>Track My Bus </Link>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            overflow: 'hidden',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                            marginBottom: '15px',
                        }}>
                            Quick Actions
                        </Typography>
                        <Grid sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', }}>
                            <Grid>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '13px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#717182',
                                }}>Phone Support</Typography>
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.PhoneStyle}>
                                    24/7
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', }}>
                            <Grid>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '13px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#717182',
                                }}>Live Chat</Typography>
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.PhoneStyle}>
                                    24/7
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', }}>
                            <Grid>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '13px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#717182',
                                }}>Email Response</Typography>
                            </Grid>
                            <Grid>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#717182',
                                }}>
                                    2-4 hours
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid size={{ md: 8, xs: 12 }}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            overflow: 'hidden',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                            marginBottom: '20px',
                        }}>
                            Frequently Asked Questions
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 9, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>
                                    Booking Related
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 3, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    textAlign: 'center',
                                    color: '#030213',
                                    borderRadius: '6px',
                                    border: 'solid 1px #e5e5e5',
                                    backgroundColor: '#fff',
                                    padding: '5px',
                                }}>
                                    12 questions
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: '25px', }}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>How to book a bus ticket?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            How to book a bus ticket?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                    <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>Can I modify my booking?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            Can I modify my booking?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                    <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>What payment methods are accepted?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            What payment methods are accepted?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                        <Grid sx={{ borderBottom: '1px solid #ddd', width: '100%', marginTop: '20px', marginBottom: '20px' }}></Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 9, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>
                                    Cancellation & Refund
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 3, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    textAlign: 'center',
                                    color: '#030213',
                                    borderRadius: '6px',
                                    border: 'solid 1px #e5e5e5',
                                    backgroundColor: '#fff',
                                    padding: '5px',
                                }}>
                                    6 questions
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: '25px', }}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>How to cancel my ticket?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            How to cancel my ticket?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>What to do if bus is delayed?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            What to do if bus is delayed?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>What are the cancellation charges?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            What are the cancellation charges?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                        <Grid sx={{ borderBottom: '1px solid #ddd', width: '100%', marginTop: '20px', marginBottom: '20px' }}></Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 9, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>
                                    Travel Related
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 3, xs: 6 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    textAlign: 'center',
                                    color: '#030213',
                                    borderRadius: '6px',
                                    border: 'solid 1px #e5e5e5',
                                    backgroundColor: '#fff',
                                    padding: '5px',
                                }}>
                                    8 questions
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: '25px', }}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>How to track my bus?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            How to cancel my ticket?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>What to do if bus is delayed?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            What to do if bus is delayed?
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <Typography component="span" sx={styleCss.CommonBookStyle}>Boarding point details</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={styleCss.SubCommunTicket}>
                                            Boarding point details
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }} sx={{ textAlign: 'center' }}>
                                <Button variant="outlined" sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    fontStretch: 'normal',
                                    fontStyle: 'normal',
                                    lineHeight: 'normal',
                                    letterSpacing: '0.24px',
                                    textAlign: 'center',
                                    color: '#030213',
                                    textTransform: 'capitalize',
                                    borderRadius: '6px',
                                    border: '1px solid #e5e5e5',
                                    backgroundColor: '#fff',
                                    marginTop: '20px',
                                }} onClick={() => navigate('/viewallfaq')}>View All FAQs</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid >
            </Grid >
        </>
    )
}

export default Help